module.exports = __webpack_public_path__ + "img/footer-feedback-white.36afc311.png";